// Contrato da rota entre a Lista de Obras e a Nova Obra, que abre como modal sobre ela (rota filha): nenhuma das duas
// telas importa da outra.

/** Estado de navegação com que a Lista abre a Nova Obra: sair volta no histórico, como o voltar do navegador. */
export interface NovaObraEntrada {
  readonly daLista: true;
}

/** Lê o `location.state` da Nova Obra: só a entrada que a Lista manda conta como vinda dela. */
export function isNovaObraEntrada(state: unknown): state is NovaObraEntrada {
  return (
    typeof state === "object" && state !== null && "daLista" in state && state.daLista === true
  );
}

/** Contexto do `Outlet` da Lista, que fica ao fundo do modal. */
export interface NovaObraRotaContexto {
  readonly recarregarLista: () => void;
  /** Toast de sucesso no host da Lista: continua na tela depois que o modal fecha. */
  readonly avisarSucesso: (mensagem: string, detalhe?: string) => void;
}
